import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { SimpleTextEditor } from 'components/inputs/simpleTextEditor';
import { CreateChancel, Input, SelectAutocompleteMultiple } from 'components';
import { goalTypes } from 'fragments';
import { httpRequestsOnSuccessActions, libraryActions } from 'store';
import { FindLoad, useModal, FindSuccessItem, goalDataTypes, goalDataTypeEnums, onModelFolderEnum } from 'utils';

export const AddFolder = ({ info, onModel, requestParams }) => {
    const ACTION_TYPE = info ? 'EDIT_LIBRARY_FOLDER' : 'CREATE_LIBRARY_FOLDER';
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const { handleSubmit, control, reset } = useForm();

    useEffect(() => {
        if (info) {
            const params = {
                ...info,
                description: info?.description || '',
            };

            reset(params);
        }
    }, [info]);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
        }
    }, [success]);

    const handleCreate = (data) => {
        const params = {
            ...data,
            onModel,
            description: data.description,
        };

        if (info) {
            dispatch(libraryActions.editLibraryFolder(info.id, params, { ...requestParams, onModel }));
        } else {
            dispatch(libraryActions.createLibraryFolder(params, { ...requestParams, onModel }));
        }
    };

    return (
        <div style={{ width: 1000, maxWidth: '100%' }}>
            <p className="modal-header-title">{info ? 'Edit Folder' : 'Add New Folder'}</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <div className="flex-align-start" style={{ gap: 16 }}>
                        <Input
                            name="name"
                            label="Folder Name*"
                            variant="outlined"
                            control={control}
                            rules={{
                                required: 'Folder name is required.',
                            }}
                        />

                        <SelectAutocompleteMultiple
                            name={`dataType`}
                            label={'Data Collection Method*'}
                            control={control}
                            options={
                                onModel === onModelFolderEnum.OPTION
                                    ? goalDataTypes?.filter((d) => d.id === goalDataTypeEnums.PERCENT || d.id === goalDataTypeEnums.RATING)
                                    : goalDataTypes
                            }
                            rules={{ required: 'Mode is required.' }}
                            renderValue={(option) => option?.label}
                            disabled={info?.id}
                        />
                    </div>

                    {onModel === onModelFolderEnum.TARGET && (
                        <div className="full-width">
                            <SelectAutocompleteMultiple
                                name={`goalType`}
                                label={'Type*'}
                                control={control}
                                options={goalTypes}
                                renderValue={(option) => option?.label}
                                rules={{ required: 'Type is required.' }}
                            />
                        </div>
                    )}

                    <p className="goal-editor-title">Objective</p>

                    <Controller
                        control={control}
                        name="description"
                        defaultValue={''}
                        rules={{
                            validate: (value) => {
                                const strippedText = value.replace(/<[^>]*>/g, '').trim();
                                return strippedText.length > 0 || 'Objective is required.';
                            },
                        }}
                        // rules={{
                        //     required: 'Objective is required.',
                        // }}
                        render={({ field, fieldState: { error } }) => (
                            <SimpleTextEditor
                                value={field.value}
                                onChange={(val) => field.onChange(val)}
                                placeholder="Write Here..."
                                error={error}
                            />
                        )}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
